export default __webpack_public_path__ + "static/16-bd9223f902d3853bf6c68f7c784dba7d.jpg";